// src/store/authStore.js
import { create } from "zustand";
import { persist } from "zustand/middleware";

// Initialize selectedCompany from localStorage companyId
const getInitialSelectedCompany = () => {
  const companyId = localStorage.getItem("companyId");
  if (companyId) {
    return { _id: companyId, companyId: companyId };
  }
  return null;
};

const useAuthStore = create(
  persist(
    (set, get) => ({
      selectedCompany: getInitialSelectedCompany(),
      hasHydrated: false,

      setSelectedCompany: (company) => {
        // If company is provided, use it; otherwise get companyId from localStorage
        if (company) {
          set({ selectedCompany: company });
        } else {
          // Get companyId from localStorage
          const companyId = localStorage.getItem("companyId");
          if (companyId) {
            set({ selectedCompany: { _id: companyId, companyId: companyId } });
          }
        }
      },
      
      setHasHydrated: () => {
        set({ hasHydrated: true });
        // Initialize selectedCompany from localStorage after hydration if not already set
        if (!get().selectedCompany) {
          const companyId = localStorage.getItem("companyId");
          if (companyId) {
            set({ selectedCompany: { _id: companyId, companyId: companyId } });
          }
        }
      },
      reset: () => set({ selectedCompany: null }),
    }),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
      onRehydrateStorage: () => (state) => {
        state.setHasHydrated?.();
      },
    }
  )
);

export default useAuthStore;
